import type { Editor } from '../editor';

export const editors = new Map<number, Editor>();
